import { createContext } from "react";

export const WindowSize = createContext(null);
